// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__BM-2F","Active":"Button_Active__9d+lT"};